export default __webpack_public_path__ + "static/media/06.de77acf1.jpg";